// Sprint 3.1 — Versão canônica da Política de Não-Retaliação (LGP-02).
//
// Bump esta string sempre que o conteúdo de docs/policy/LGP-02-politica-nao-retaliacao.md
// mudar materialmente (não apenas typos). Middleware requirePolicyAccepted compara
// strict equality contra UserRecord.policyVersion — qualquer divergência força
// re-aceite pelo modal antes de liberar acesso a rotas autenticadas.
//
// Formato: 'LGP-02-<major>.<minor>'. Major bump = mudança de garantias/sanções
// (re-aprovação Diretoria obrigatória). Minor = revisão editorial sem mudança
// de direito substantivo (re-aceite usuário ainda é exigido como confirmação).

export const LGP_02_VERSION = 'LGP-02-0.1' as const;
export type Lgp02Version = typeof LGP_02_VERSION;

/** True se o user aceitou a versão atual. Usado pelo middleware. */
export function hasAcceptedCurrentPolicy(user: {
  readonly policyAcceptedAt?: number;
  readonly policyVersion?: string;
}): boolean {
  return user.policyAcceptedAt !== undefined && user.policyVersion === LGP_02_VERSION;
}
